import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../index.css";
import React from "react";
import { Link } from "react-router-dom";
export default function Navbar() {
  return (
    <div>
      <nav className="navbar bg-primary">
        <div className="container">
          <Link to={"/"} className="link_">
            <i className="bi bi-check2-circle"></i>
            Home
          </Link>
          <div className="todo_links">
            <Link to={"/components/Notes"} className="link_">
              Trash
            </Link>
            <Link to={'/components/Account'} className="link_">
              <i className="bi bi-person-circle"></i>
            </Link>
          </div>
        </div>
      </nav>
    </div>
  );
}
